// Copyright (c) StrangeBee 2024

import React, { createContext, ReactElement, ReactNode, ReactText, useState } from 'react';
import { FilterInput } from 'thehive-sdk';
import useFilters, { FilterInputForm } from '@Hooks/useFilters';

export interface ListContextInterface {
    selectedKeys: ReactText[];
    setSelectedKeys: React.Dispatch<React.SetStateAction<ReactText[]>>;
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
    itemsPerPage: number;
    setItemsPerPage: React.Dispatch<React.SetStateAction<number>>;
    editFilters: boolean;
    setEditFilters: React.Dispatch<React.SetStateAction<boolean>>;
    filters: FilterInputForm[];
    setFilters: React.Dispatch<React.SetStateAction<FilterInputForm[]>>;
    addFilter: (filter: FilterInput) => void;
    removeFilter: (index: number) => void;
    tempFilters: FilterInputForm[];
    setTempFilters: React.Dispatch<React.SetStateAction<FilterInputForm[]>>;
    addTempFilter: (filter: FilterInputForm) => void;
    removeTempFilter: (index: number) => void;
    applyFilters: () => void;
    clearFilters: () => void;
}

export const ListContext = createContext<ListContextInterface>({
    selectedKeys: [],
    setSelectedKeys: () => {
        //empty
    },
    page: 0,
    setPage: () => {
        //empty
    },
    itemsPerPage: 10,
    setItemsPerPage: () => {
        //empty
    },
    editFilters: false,
    setEditFilters: () => {
        // empty
    },
    filters: [],
    setFilters: () => {
        //empty
    },
    addFilter: () => {
        //empty
    },
    removeFilter: () => {
        //empty
    },
    tempFilters: [],
    setTempFilters: () => {
        //empty
    },
    addTempFilter: () => {
        //empty
    },
    removeTempFilter: () => {
        //empty
    },
    applyFilters: () => {
        //empty
    },
    clearFilters: () => {
        //empty
    },
});

interface ListProviderProps {
    children?: ReactNode;
}

const ListProvider = ({ children }: ListProviderProps): ReactElement => {
    const [selectedKeys, setSelectedKeys] = useState<ReactText[]>([]);

    const [page, setPage] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);

    const filters = useFilters();

    return (
        <ListContext.Provider
            value={{
                selectedKeys,
                setSelectedKeys,
                page,
                setPage,
                itemsPerPage,
                setItemsPerPage,
                ...filters,
            }}
        >
            {children}
        </ListContext.Provider>
    );
};

export default ListProvider;
